module.exports = __webpack_public_path__ + "img/carousel-3.ef8fb6db.jpg";